<div class="row" style="max-width: 80%;margin-left: auto; margin-right: auto;">
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: left; align-self: end;">
            Location: {{ serviceInstance?.name  || 'N/A' }}
        </h4>
    </div>
    <div class="col-sm-6">
        <h1 class="page-label">Carton Audit - Dashboard</h1>
    </div>
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: right; align-self: end;">
            Carton: {{ auditState?.auditAttempt?.cartonId || 'N/A' }}
        </h4>
    </div>
</div>

<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">#</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">UPC</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Style</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Color</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Size</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Packer</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Dimension</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader"># Expected</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader"># Found</th>
        </tr>
    </thead>
    <tbody>
        <tr role="row" *ngFor="let lineItem of auditState?.auditAttempt?.lineItems; index as i; trackBy: trackByFunction"
            [class.green-highlight]="isSuccessRow(lineItem)"
            [class.red-highlight]="isErrorRow(lineItem)"
            [class.yellow-highlight]="isPartialRow(lineItem)"
            [class.gray-highlight]="isUnknownRow(lineItem)">
            <td>{{ i + 1 }}</td>
            <td>{{ lineItem?.itemId || lineItem?.upc }}</td>
            <td>{{ lineItem?.description || lineItem?.style }}</td>
            <td>{{ lineItem?.color }}</td>
            <td>{{ lineItem?.size }}</td>
            <td>{{ lineItem?.packer }}</td>
            <td>{{ lineItem?.dimension }}</td>
            <td>{{ lineItem?.numberExpected }}</td>
            <td>{{ lineItem?.readQuantity || lineItem?.numberFound }}</td>
        </tr>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-6">
        <button class="btn btn-primary" (click)="onStartReaderClicked()"
            [disabled]="auditState?.readerRunning === 'Started' || isActionBeingPerformed">
            Start Reader
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="onStopReaderClicked()"
            [disabled]="auditState?.readerRunning !== 'Started' || isActionBeingPerformed">
            Stop Reader
        </button>
    </div>
    <div class="col-sm-6 text-right">
        <button class="btn btn-primary" (click)="onClearReadsClicked()" [disabled]="isActionBeingPerformed">
            Clear Reads
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="onClearAllClicked()" [disabled]="isActionBeingPerformed">
            Clear All
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="onProcessClicked()" [disabled]="isActionBeingPerformed">
            Process
        </button>
    </div>
</div>
<div class="print-container">
    <h1 class="page-label">&nbsp;</h1>
</div>
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>